"use client";

import React from "react";
import { Zap, MessageSquare, TrendingUp } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const engineFeatures = [{
  title: "Elite Craftsmanship",
  description: "Our team of dedicated professionals brings meticulous attention to every blade of grass and stone placement.",
  icon: Zap
}, {
  title: "Heritage Quality",
  description: "We utilize time-tested techniques combined with modern equipment to ensure your landscape thrives for generations.",
  icon: MessageSquare
}, {
  title: "Reliable Scheduling",
  description: "Punctuality is our promise. We respect your time and property, delivering consistent results on every visit.",
  icon: TrendingUp
}];
export default function TheViralityEngine() {
  return <section data-section-id="224052" id="whychooseus" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <style>{`
        @keyframes glitch-jitter {
          0% { transform: translate(0, 0); }
          20% { transform: translate(-2px, 1px); }
          40% { transform: translate(2px, -1px); }
          60% { transform: translate(-1px, 2px); }
          80% { transform: translate(1px, -2px); }
          100% { transform: translate(0, 0); }
        }
        .group:hover .animate-glitch {
          animation: glitch-jitter 0.2s linear infinite;
        }
      `}</style>

      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight mb-4 text-primary">
            Why HWYM? Meet Tyler and Sean, the guys who truly care about your yard.
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-default text-lg">
            We’re Tyler and Sean—two young guys who genuinely love turning your outdoor space into something special.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {engineFeatures.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              {}
              <Card className="h-full bg-card border-border/40 transition-all duration-500 ease-out group-hover:-translate-y-2 group-hover:bg-accent/30 group-hover:border-primary/30 relative overflow-hidden rounded-lg shadow-md">
                
                {}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-primary opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                <CardHeader className="pt-8 pb-4 relative z-10">
                  <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-lg bg-secondary/10 border border-secondary/20 shadow-sm">
                    <feature.icon className="w-7 h-7 text-secondary drop-shadow-sm animate-glitch transition-transform" />
                  </div>
                  <CardTitle className="text-2xl font-bold font-default tracking-wide text-primary">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="pb-8 relative z-10">
                  <CardDescription className="text-muted-foreground font-default text-base leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}